import { memo, useEffect } from "react";
import { useAppDispatch } from "../../hooks/store-hooks";
import { clearHomeData } from "../../store/slices/homeSlice";
import { ROUTES } from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import { useGetOnboardingDataQuery } from "../../store/api/onboardingApi";

interface AuthLayoutProps {
  children: React.ReactNode;
  screenName?: string;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, screenName }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {
    data: homeData,

    refetch,
  } = useGetOnboardingDataQuery(screenName, { skip: !screenName });

  useEffect(() => {
    dispatch(clearHomeData());
    if (homeData?.data?.is_completed) {
      navigate(ROUTES.HOME);
    }
  }, [homeData]);

  useEffect(() => {
    if (screenName) {
      refetch();
    }
  }, [refetch, screenName]);

  return (
    <div className="flex h-screen bg-black">
      <div className="w-full lg:w-4/12 bg-black my-16 ml-16 mr-20 max-lg:ml-10 max-lg:mr-14 max-md:ml-6 max-md:mr-10">
        {children}
      </div>
      <div
        className="w-full lg:w-8/12 max-lg:hidden bg-[#1849D6] h-full flex flex-col justify-between overflow-clip"
        style={{
          backgroundImage: `url('/assets/auth/Checks.svg')`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="ml-20 mt-28 text-5xl lg:text-7xl font-semibold text-white">
          Your Journey to Financial Freedom
        </div>
        <div className="w-full flex justify-end auth-hero-image">
          <img
            alt="Sharan"
            src="/assets/auth/Sharan.png"
            className="w-[600px] h-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default memo(AuthLayout);
